<li class="filter-list-item">
    <input required="required" (click)="itemChanged($event);" [checked]="item.checked" class="filter-category filter-input" [id]="type + ' ' + item.Key" [name]="type + ' ' + item.Key" type="checkbox">
    <label [for]="type + ' ' + item.Key">
        <span class="icon is--icon-check">
          <svg class="icon-svg">
              <use xlink:href="/assets/gfx/svg-sprite.svg#icon-check"></use>
          </svg>
        </span>
        {{labels[item.Key] || item.Key}} <small>({{item.DocCount}})</small>
    </label>
</li>
